module.exports = __webpack_public_path__ + "media/images/icons/x-f49d1064b8a1a664a35a476f4ceaa3f1.svg";